import React,{useState} from 'react';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './commentBoxModal.scss';

export default ({ isOpen, toggle, title, content, link, onClickHander,type }) => {
  const [message, setMessage] = useState('')

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='next-step-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              if (link === 'manageAccount') {
                window.location.reload(false);
              }
              setMessage("")
              onClickHander('no')
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3 style={{"text-align": "left", "font-size":"16px"}}>{content}</h3>
          </div>
          <ModalBody>
            <div className='modal-content'>
              <h5 style={{"text-align": "left"}}>Add Comment<span className="star">&#42;</span></h5>
            <textarea placeholder="Type comment.." name="comment" style={{"min-height":"100px", "margin-bottom":"10px"}} required value={message}
                onChange={e => setMessage(e.target.value)}
              ></textarea>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                toggle(!isOpen)
                setMessage("")
                onClickHander('no')
              }}>
              No
            </Button>
            <Button
              type='app-green-button'
              disabled={message?false:true}
              handleClick={() => {
                toggle(!isOpen)
                onClickHander(message)
                setMessage("")
              }}>
              Yes
            </Button>

          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
